import OrderListLayout from "@/views/Orders/List/layout.vue";
import OrderDetailLayout from "@/views/Orders/List/OrderDetail/index.vue";
import MyOrderList from "@/views/Orders/List/My/index.vue";
import MemeberOrderList from "@/views/Orders/List/Member/index.vue";
import Complete from "@/views/Orders/Complete/layout.vue";
import NewOrder from "@/views/Orders/NewForm/layout.vue";
import purchase from "@/views/Orders/Cart/layout.vue";
export default [
  {
    path: "complete",
    component: Complete
  },
  {
    path: "form",
    name: "orderForm",
    component: NewOrder
  },
  {
    path: "form/:id/:flag",
    name: "orderFormEdit",
    component: NewOrder
  },
  {
    path: "purchase",
    name: "orderPurchase",
    component: purchase
  },
  {
    path: "list",
    name: "orderList",
    component: OrderListLayout,
    children: [
      {
        path: "my",
        component: MyOrderList
      },
      {
        path: "member",
        component: MemeberOrderList,
        props: (route) => ({ p: route.query.p, perPage: route.query.perPage })
      }
    ]
  },
  {
    path: "list/my/:orderId",
    name: "orderDetail",
    component: OrderDetailLayout
  }
];
